// extracted by mini-css-extract-plugin
export default {"infoIcon":"NotifyMeButton_infoIcon__WN1r0","root":"NotifyMeButton_root__zgGPH"};